export default __webpack_public_path__ + "04e0f30e1de8ed36f7084a7b405de313.png";